import * as echarts from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import {
  BarChart,
  CustomChart,
  GaugeChart,
  LineChart,
  PieChart,
  RadarChart,
} from 'echarts/charts'
import {
  DataZoomComponent,
  DatasetComponent,
  GraphicComponent,
  GridComponent,
  LegendComponent,
  PolarComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components'
import type { App } from 'vue'

function registerCharts(app: App<Element>) {
  app.config.globalProperties.$echarts = echarts
  echarts.use([
    CanvasRenderer,
    BarChart,
    GaugeChart,
    LineChart,
    PieChart,
    RadarChart,
    GridComponent,
    TooltipComponent,
    LegendComponent,
    DataZoomComponent,
    GraphicComponent,
    TitleComponent,
    PolarComponent,
    CustomChart,
    DatasetComponent,
  ])
}

export default {
  install: (app: App<Element>) => {
    registerCharts(app)
  },
}
